import React, { Component } from 'react';
import '../css/styles.css';
import WebSkin from './toys/WebsiteWrapper';
import Survey from './survey';
const START = 0;
const LIST_RANGE = 1;
export default class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			phase: START,
			input: {},
		};
		this.switchStateTwo = this.switchStateTwo.bind(this);
	}
	switchStateTwo(props) {
		this.setState({ phase: LIST_RANGE, input: props, x: 'x' });
		console.log(LIST_RANGE, props);
		console.log(this.state);
	}
	render = () => {
		let bodySkin = '';
		if (this.state.phase == LIST_RANGE) {
			bodySkin = 'body_dash';
		}

		const renderPhase = () => {
			if (this.state.phase == START) {
				return <Survey Submit={this.switchStateTwo} />;
			} else if (this.state.phase == LIST_RANGE) {
				return (
					<div>
						{this.state.input.map(item => (
							<div>
								{item.id}:{item.value}
							</div>
						))}
					</div>
				);
			}
		};
		return <WebSkin className={bodySkin}>{renderPhase()}</WebSkin>;
	};
}
